import { UseTreeDragDropState } from 'shared/data_tree/types';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn as createStore } from 'zustand/traditional';

const useTreeDragDrop = createStore<UseTreeDragDropState>(
    (set) => ({
        dragNode: undefined,
        targetNode: undefined,
        pointer: undefined,
        previewX: 0,
        previewY: 0,
        startMove: (dragNode, previewX, previewY) =>
            set({ dragNode, previewX, previewY }),
        endMove: () =>
            set({
                dragNode: undefined,
                targetNode: undefined,
            }),
        updateTarget: (targetNode) => {
            set({ targetNode });
        },
        clearTarget: () => set({ targetNode: undefined }),
        updatePreviewPosition: (previewX, previewY) => set({ previewX, previewY }),
    }),
    shallow,
);

export { useTreeDragDrop };
